// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { RmsDemoProduct } from '../app/model/rms-demo-product';

export const environment = {
    production: false,
    apiUrl: '/api/lovcash/',
    transactionUrl: '/transaction/',
    // RMS Simulator "Quick Add" list - one entry per demo product, resolved against THIS
    // environment's own catalogue/supplier data (a supplierCode/productCode/barcode valid in
    // dev is very unlikely to also be valid in uat/prod). Sourced from the team's own known-good
    // dev test request - the "Neto" line is a DELIBERATE negative test (invalid/unresolvable
    // supplier), included on purpose to demo the line-level-ineligible-not-request-fatal
    // behaviour rather than a request-wide rejection.
    rmsSimulatorDemoProducts: [
        {
            name: 'PepsiCo Bakery item (valid)',
            supplierCode: 'PEPSICO_BAKERY',
            productCode: '7977633579194',
            barcode: '121212121212',
            sellingPrice: 20.49,
        },
        {
            name: 'Neto (invalid supplier - negative test)',
            supplierCode: 'Neto',
            productCode: '13123131313',
            barcode: '444444444444',
            sellingPrice: 15,
        },
        {
            name: 'Tiger item (valid)',
            supplierCode: 'TIGER',
            productCode: '44144598581434',
            barcode: '6001120612641',
            sellingPrice: 10,
        },
    ] as RmsDemoProduct[],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
